var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "padd30 seller-style" },
    [
      _vm._l(_vm.list, function(item, index) {
        return [
          _c(
            "div",
            {
              key: item.code,
              staticClass: "f18 fb normal gray_2",
              class: { "mar30-t": index !== 0 }
            },
            [_vm._v(_vm._s(item.name))]
          ),
          _vm._l(item.entityList, function(item2, index2) {
            return [
              _c(
                "div",
                {
                  key: item2.code,
                  staticClass: "flex f15 items-center pad15-tb border-b",
                  class: { "border-0": index2 === 0 && index === 0 }
                },
                [
                  _c("div", { staticClass: "flex-auto" }, [
                    _c("div", { staticClass: "flex-auto fb" }, [
                      _vm._v(_vm._s(item2.name))
                    ]),
                    _c("div", { staticClass: "mar10-r" }, [
                      _vm._v(_vm._s(item2.attrExplain))
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "text-right mar10-r" },
                    [
                      item2.code === "purchaser"
                        ? _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              on: {
                                change: function(value) {
                                  return _vm.updateBasic(value, item, item2)
                                }
                              },
                              model: {
                                value: item2.attr[0].value,
                                callback: function($$v) {
                                  _vm.$set(item2.attr[0], "value", $$v)
                                },
                                expression: "item2.attr[0].value"
                              }
                            },
                            _vm._l(_vm.operator, function(purchaser) {
                              return _c("el-option", {
                                key: purchaser.boId,
                                attrs: {
                                  label: purchaser.userName,
                                  value: String(purchaser.boId)
                                }
                              })
                            }),
                            1
                          )
                        : _c("el-switch", {
                            attrs: { "active-value": 1, "inactive-value": 0 },
                            on: {
                              change: function(value) {
                                return _vm.updateBasic(value, item, item2)
                              }
                            },
                            model: {
                              value: item2.value,
                              callback: function($$v) {
                                _vm.$set(item2, "value", $$v)
                              },
                              expression: "item2.value"
                            }
                          }),
                      item2.attr &&
                      item2.attr[0] &&
                      item2.attr[0].type === "input"
                        ? _c(
                            "div",
                            { staticClass: "flex items-center mar10-t" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item2.attr[0].text) +
                                  "\n            "
                              ),
                              _c("el-input-number", {
                                staticClass: "mar10-l",
                                attrs: { size: "small", min: 0, precision: 2 },
                                on: {
                                  change: function(currentValue) {
                                    return _vm.updateBasic(
                                      currentValue,
                                      item,
                                      item2
                                    )
                                  }
                                },
                                model: {
                                  value: item2.attr[0].value,
                                  callback: function($$v) {
                                    _vm.$set(item2.attr[0], "value", $$v)
                                  },
                                  expression: "item2.attr[0].value"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              item2.code === "is_Automatic_Dispatch"
                ? _c(
                    "div",
                    {
                      key: item2.code + "b",
                      staticClass: "flex radius5 pad20 flex automatic"
                    },
                    [
                      _c("i", {
                        staticClass: "el-icon-warning-outline f24 yellow"
                      }),
                      _c("div", { staticClass: "mar15-l flex-auto" }, [
                        _c("div", { staticClass: "f16" }, [
                          _vm._v("自动派单规则")
                        ]),
                        _c(
                          "div",
                          [
                            _vm._v(
                              "\n            1、商品与供应商商品关系设置完成\n            "
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "blue mar30-l",
                                attrs: { to: "/mj/goodRelevance" }
                              },
                              [_vm._v("查看设置")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _vm._v(
                              "\n            2、客户订单为第一次支付且达到合同约定的付款比例\n            "
                            ),
                            _c(
                              "router-link",
                              {
                                staticClass: "blue mar30-l",
                                attrs: { to: "/mj/contract" }
                              },
                              [_vm._v("查看设置")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _vm._v("3、采购订单收货地址已设置"),
                            _c(
                              "router-link",
                              {
                                staticClass: "blue mar30-l",
                                attrs: { to: "/mj/scm/receive" }
                              },
                              [_vm._v("查看设置")]
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ]
          })
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }